<template>
<div class="pageMessage">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
        <div class="list">
            <div class="item" v-for="msg in msgList" :key="msg.id" @click="goInfo(msg)">
                <div class="title">{{ msg.title }}</div>
                <van-image class="img" fit="contain" :show-error="false" :show-loading="false" :src="msg.thumb" v-if="msg.thumb" />
                <div class="more">查看更多</div>
            </div>
        </div>
    </van-list>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            token: this.$store.getters.token,
            type: this.$route.query.type,
            loading: false,
            finished: false,
            pages: {
                page: 1,
                size: 10
            },
            msgList: [],
            token: null
        };
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '消息列表',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
            var memberParams = {
                data: {
                },
            }
            //加载用户信息
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    methods: {
        // 获取列表
        getData() {
            var params = {
                token: this.token,
                sys_msg_cate_id: this.type, // 1 系统消息 2站内消息 (默认1)
                page: this.pages.page,
                size: this.pages.size
            }
            this.$api.xiaoxi.msgList(params).then(res => {
                if (res.code == 200) {
                    var list = res.result
                    if (list.length != 0) {
                        for (var i in list) {
                            this.msgList.push(list[i])
                        }
                    } else {
                        this.finished = true
                    }
                } else {
                    this.finished = true
                }
                this.pages.page++
                this.loading = false
            })
        },
        // 消息详情
        goInfo(msg) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo",memberParams,(data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/message/system/info?id=' + msg.id
                            }
                        }
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                });     
            } else {
                // 1 系统消息  2站内消息
                this.$router.push({
                    path: '/message/system/info',
                    query: {
                        id: msg.id
                    }
                })
            }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
